//Note: to test gadget in development replace advantage with advantage-development in apiUrl
//load all the available collections for the selected brand
async function fetchCollectionDetails(shopDomain,gids) {
    // Ensure gids is an array
    if (!Array.isArray(gids)) {
        console.error("Please provide an array of GIDs.");
        return;
    }

    // Join the array into a comma-separated string for the query parameter
    const idsParam = gids.join(',');

    // Gadget url route
    const apiUrl = `https://${shopDomain}/apps/advantage/get/collection-details?ids=${encodeURIComponent(idsParam)}`;    
    try {
        const response = await fetch(apiUrl);

        if (!response.ok) {
        // Handle HTTP errors (e.g., 400, 500)
        const errorData = await response.json();
        console.error(`Error fetching collection details: ${response.status} ${response.statusText}`, errorData);
        // You might want to display an error message to the user here
        return null;
        }

        // Parse the JSON response
        const data = await response.json();//sample data { gid: 'gid://shopify/Collection/123', handle: 'some-handle', title: 'Some Title' }
        //console.log("Fetched collection details:", data);
        return data;

    } catch (error) {
        console.error("Network error or issue fetching data:", error);
        return null;
    }
}
//load products for the selected device
async function fetchCollectionProducts(shopDomain,collectionId) {
    //returning if no collectionId is passed
    if(!collectionId) return;
    const apiUrl = `https://${shopDomain}/apps/advantage/get/collection-products?collectionId=${collectionId}`;
    try{
        const response = await fetch(apiUrl);
        if(!response.ok) {
            // Handle HTTP errors (e.g., 400, 500)
            const errorData = await response.json();
            console.error(`Error fetching collection details: ${response.status} ${response.statusText}`, errorData);
            return
        }
        const data = await response.json();
        return data;
    }
    catch(error) {
        console.error("issue fetching products:", error);
    }  
}
//submit screen/case registration form data to the gadget
async function submitRegistration(shopDomain,data) {
    const apiUrl = `https://${shopDomain}/apps/advantage/post/product-registrations`;
    try{
        const submitResponse = await fetch(apiUrl,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        });
        if (!submitResponse.ok && submitResponse.status !==409) {
        throw new Error('Network response was not ok');
        }
    
        const result = await submitResponse.json();
        return result;
    }
    catch(error){
        console.error("issue while submitting the screen registration",error);
    }
    }
//display product dropdoen options
function displayProductDropdownOptions(element,productData) {
    productData.forEach((pdata,pidx)=>{
        if(pdata?.status === "active") {
            const productOption = document.createElement('option');
            const productName = pdata.customProductType ? pdata.customProductType : '';
            //productOption.value = pdata.id ? pdata.id : ''
            productOption.textContent = productName;
            productOption.dataset.productTitle = productName;
            productOption.dataset.productType = pdata?.productType;
            if (pdata?.image) {
            productOption.dataset.image = pdata?.image?.originalSrc;
            }
            pdata.variants.forEach((pdv,vidx) => {
            productOption.dataset.productVariantId = pdv.id;
            productOption.dataset.productVariantPrice = pdv.price;
            //productOption.dataset.productVariantSku = pdv.sku;
            productOption.value = pdv.sku ? pdv.sku : ''
            productOption.dataset.shopifyPid = pdata.id?pdata.id:'';
            element.appendChild(productOption);
            })
        }
    })
}
// Utility to reset dropdown
function resetDropdown(element, placeholder) {
    element.innerHTML = `<option value="">Select ${placeholder}</option>`;
}

//handle screen and case upsell products 
//if we want to pass any custom data to the cart we have to use properties keyword

async function handleUpsellProducts(productVariant, upgradeVariant) {
    window.Spinner?.show();
    const cart = await fetch('/cart.js').then(res => res.json());
    const linkedGroupId = Date.now().toString();

    let existingUpgradeItem = cart.items.find(item => item.variant_id == upgradeVariant);

    let finalLinkedGroupId = linkedGroupId;
    if (existingUpgradeItem) {
        // If upsell already exists, use its linked ID
        finalLinkedGroupId = existingUpgradeItem.properties?._linkedUpsellGroupId || linkedGroupId;
    }

    const parentProperties = {
        _parentUpsellProductVId: productVariant,
        _linkedUpsellGroupId: finalLinkedGroupId
    };

    const upgradeProperties = {
        _upsellUpgradeProduct: upgradeVariant,
        _linkedUpsellGroupId: finalLinkedGroupId
    };

    // Step 1: Add parent product
    await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: productVariant, quantity: 1, properties: parentProperties })
    });

    // Step 2: Add or update upsell product
    if (existingUpgradeItem) {
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: existingUpgradeItem.key, // ✅ Must use line item key
                quantity: existingUpgradeItem.quantity + 1,
                properties: upgradeProperties
            })
        });
    } else {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: upgradeVariant, quantity: 1, properties: upgradeProperties })
        });
    }

    // Step 3: Refresh cart & trigger events
    const updatedCart = await fetch('/cart.js').then(res => res.json());
    document.dispatchEvent(new CustomEvent('variant:add', { detail: { cart: updatedCart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { cart: updatedCart, baseEvent: 'variant:add' }
    }));
    window.Spinner?.hide();
}

//function to check/restrict replacement products 
async function checkCartForReplacementProducts() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
  
      const productFetches = cart.items.map(item =>
        fetch(`/products/${item.handle}.js`)
          .then(productResponse => productResponse.json())
          .then(product => {
            const productTags = product.tags.map(tag => tag.toLowerCase());
            const isReplacement = productTags.includes("replacement");
            return {
              item,
              isReplacement
            };
          })
          .catch(error => {
            console.error(`Error fetching product details for ${item.handle}:`, error);
            return { item, isReplacement: false }; // fallback
          })
      );
  
      const results = await Promise.all(productFetches);
  
      // Filtering replacement products
      const replacementItems = results.filter(r => r.isReplacement);
      const totalReplacementQuantity = replacementItems.reduce(
        (sum, r) => sum + r.item.quantity,
        0
      );
  
      if (replacementItems.length >= 2) {
        return true;
      }
  
      if (totalReplacementQuantity >= 2) {
        return true;
      }
  
      return false;
  
    } catch (error) {
      console.error("Error checking replacement products in cart:", error);
      return false;
    }
}

//call to gadget get customer  register products
async function fetchRegisteredProducts(shopDomain) {
    const apiUrl = `https://${shopDomain}/apps/advantage/get/registered-products`;

    try {
        const response = await fetch(apiUrl);
        if (response.status === 200) {
        const data = await response.json();
        return data.products || [];
        } else {
        console.error('Failed to fetch products:', response.status);
        return [];
        }
    } catch (error) {
        window.Spinner?.hide();
        console.error('Error fetching products:', error);
        return [];
    }
}

//grouping products based on deviceText value
function groupProductsByDevice(products) {
    const groupedProducts = {};

    // 1. Group products by device
    products.forEach(product => {
        const deviceName = product?.productDeviceText?.trim();
        if (!deviceName) return;

        if (!groupedProducts[deviceName]) {
            groupedProducts[deviceName] = {
                deviceName: deviceName,
                products: []
            };
        }
        groupedProducts[deviceName].products.push({ ...product });
    });

    // 2. Process each device group
    Object.values(groupedProducts).forEach(group => {
        if (group.products.length === 0) return;

        // Separate products by type
        const productGroups = {
            cases: [],
            others: []
        };

        group.products.forEach(product => {
            if (product.productType === "cases") {
                productGroups.cases.push(product);
            } else {
                productGroups.others.push(product);
            }
        });

        // Process each product group
        Object.entries(productGroups).forEach(([type, products]) => {
            if (products.length === 0) return;

            const uniqueUpsells = new Map();

            // Collect all unique upsells
            products.forEach(product => {
                if (product.upsells?.length) {
                    product.upsells.forEach(upsell => {
                        const upsellId = upsell?.data?.id;
                        if (upsellId && !uniqueUpsells.has(upsellId)) {
                            uniqueUpsells.set(upsellId, upsell);
                        }
                    });
                }
            });

            // Remove upsells from all products
            products.forEach(product => delete product.upsells);

            // Add to last product if any upsells exist
            if (uniqueUpsells.size > 0) {
                products[products.length - 1].upsells = Array.from(uniqueUpsells.values());
            }
        });

        // Recombine products (cases first, then others)
        group.products = [...productGroups.cases, ...productGroups.others];
    });

    return Object.values(groupedProducts);
}

//case upsell addtocart
function handleCaseUpsellAddToCart(event){
    let caseUpgradeFee = null;
    const caseUpgradeBtn = event.currentTarget;
    const caseUpgradePId = caseUpgradeBtn.getAttribute('pid');
    let caseTier = caseUpgradeBtn.getAttribute('data-caseupgrade-pid');
    if(caseTier.trim() == 'tier-1') caseUpgradeFee = '44607127683251';//shopify product id
    if(caseTier.trim() == 'tier-2') caseUpgradeFee = '44607134138547';
    if(caseTier.trim() == 'tier-3') caseUpgradeFee = '44607136235699';
    if(caseTier.trim() == 'tier-4') caseUpgradeFee = '44607137841331';
    if (!caseUpgradePId || !caseUpgradeFee) {
        console.error("Missing product ID(s).");
        return;
    }
    handleUpsellProducts(caseUpgradePId,caseUpgradeFee);
}
var clearTimeoutInterval = null;
//show replacement error message 
function showReplacementError(defaultParam = "replacementError") {
    const errorBox = document.getElementById(defaultParam);
    if (!errorBox) return;
    if(clearTimeoutInterval) {
        clearTimeout(clearTimeoutInterval);
    }
  
    errorBox.classList.remove('d-none');
  
    // Auto-hide after 2 seconds
    clearTimeoutInterval = setTimeout(() => {
      errorBox.classList.add('d-none');
    }, 3000);
}
function test(name){
    alert(name)
}
window.RegistrationHelper = {//for global access
    fetchCollectionDetails,
    fetchCollectionProducts,
    displayProductDropdownOptions,
    resetDropdown,
    submitRegistration,
    handleUpsellProducts,
    checkCartForReplacementProducts,
    handleCaseUpsellAddToCart,
    fetchRegisteredProducts,
    groupProductsByDevice,
    showReplacementError,
    test
}
